module.exports = __webpack_public_path__ + "static/media/ttc-logo.ca471be3.svg";